import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Tag } from '@app/ui';
import shortenStr from '@app/utils/shortenStr';

interface AssocItem {
    id: string | number;
    placement?: { name?: string };
    sponsor?: { name?: string };
}

interface DisplayPlcSpProps {
    assoc?: AssocItem[];
}

const DisplayPlcSp: React.FC<DisplayPlcSpProps> = ({ assoc = [] }) => {
    const { t } = useTranslation('measurement');
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded(prev => !prev);

    const first = assoc.slice(0, 2);
    const rest = assoc.slice(2);

    const renderTags = (arr: AssocItem[]) =>
        arr.map(({ placement, sponsor, id }) => {
            const name = `${placement?.name || '—'} - ${sponsor?.name || '—'}`;
            const shortName = shortenStr(20, name);
            return (
                <React.Fragment key={id}>
                    <Tooltip title={name}>
                        <Tag
                            style={{
                                fontSize: 12,
                                marginBottom: 2,
                                maxWidth: 120,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {shortName}
                        </Tag>
                    </Tooltip>
                    <br />
                </React.Fragment>
            );
        });

    return (
        <>
            {renderTags(first)}
            {!expanded && rest.length > 0 && (
                <Tag
                    color="blue"
                    style={{ fontSize: 12, cursor: 'pointer' }}
                    onClick={toggleExpanded}
                >
                    {t('socialMediaExposure.table.moreItems', {
                        count: rest.length,
                    })}
                </Tag>
            )}
            {expanded && renderTags(rest)}
        </>
    );
};

export default DisplayPlcSp;
